export const serverEndPoint = process.env.REACT_APP_API_URL;
export const serverEndPointForAuth = process.env.REACT_APP_API_URL_AUTH_SERVER;
export const websiteAddress = "https://github.com/DevelopmentDigitalTwin";
export const githubAddress = "https://github.com/DevelopmentDigitalTwin";
export const githubIssueAddress = "https://github.com/DevelopmentDigitalTwin";
